import { useTranslation } from "react-i18next";

import { Text } from "./Text";

export const Title = () => {
  const { t } = useTranslation();

  return <Text variant="h1-desctop">{t("CreativeTasks:Title")}</Text>;
};
